import { valuesProps } from "types/paymentMethods";

export interface AddressDetails {
  "Address line 1": number;
  "Address line 2": number;
  City?: number;
  Province?: number;
  State?: number;
  County?: number;
  Eircode?: number;
  Parish?: number;
  Area?: number;
  PIN?: number;
  "Postal code"?: number;
  CEDEX?: number;
  ZIP?: number;
  Emirate?: number;
  Oblast?: number;
  Island?: number;
  zipCheck?: boolean;
  zipLength?: number;
  isNumber?: boolean;
  District?: number;
  Prefecture?: number;
  Department?: number;
}

type CountryAddressListType = Record<string, AddressDetails>;

export const countryAddressList = (): CountryAddressListType => {
  return {
    AF: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    AL: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      City: 0.5,
      zipLength: 50,
      isNumber: false,
    },

    DZ: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      City: 0.5,
      zipLength: 50,
      isNumber: false,
    },

    AD: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      City: 0.5,
      zipLength: 50,
      isNumber: false,
    },

    AO: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    AI: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    AQ: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    AG: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    AR: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      City: 0.5,
      Province: 1,
      zipLength: 50,
      isNumber: false,
    },

    AM: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      City: 0.5,
      Province: 1,
      zipLength: 50,
      isNumber: false,
    },

    AW: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    AU: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      State: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    AT: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      City: 0.5,
      zipLength: 50,
      isNumber: false,
    },

    AZ: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      City: 0.5,
      zipLength: 50,
      isNumber: false,
    },

    BS: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Island: 1,
    },

    BH: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    BD: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    BB: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Parish: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    BY: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      City: 0.5,
      Oblast: 1,
      zipLength: 50,
      isNumber: false,
    },

    BE: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      City: 0.5,
      zipLength: 50,
      isNumber: false,
    },

    BZ: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    BJ: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    BM: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    BT: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    BO: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    BA: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      City: 0.5,
      zipLength: 50,
      isNumber: false,
    },

    BW: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    BV: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    BR: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      State: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    IO: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    BN: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    BG: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      City: 0.5,
      zipLength: 50,
      isNumber: false,
    },

    BF: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      CEDEX: 1,
      zipLength: 50,
      isNumber: false,
    },

    BI: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    KH: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    CM: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    CA: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Province: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    KY: {
      "Address line 1": 1,
      "Address line 2": 1,
      Island: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    CF: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    TD: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    CL: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      Province: 1,
    },

    CN: {
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
      Province: 1,
      City: 1,
      District: 1,
      "Address line 1": 1,
      "Address line 2": 1,
    },

    CO: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Department: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    KM: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    CG: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    CK: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    CR: {
      "Address line 1": 1,
      "Address line 2": 1,
      Province: 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    CI: {
      CEDEX: 1,
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      zipLength: 50,
      isNumber: false,
    },

    HR: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    CW: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    CY: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    CZ: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    DK: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    DJ: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    DM: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    DO: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    EC: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    EG: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Province: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    SV: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      Province: 1,
    },

    GQ: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    ER: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    EE: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      Province: 1,
    },

    SZ: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    ET: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    FK: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    FJ: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    FI: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    FR: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    GF: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      CEDEX: 1,
    },

    PF: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      Island: 1,
    },

    GA: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    GM: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    GE: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    DE: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    GH: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    GI: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    GR: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    GL: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    GD: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    GU: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      ZIP: 1,
      zipLength: 5,
      isNumber: true,
      zipCheck: true,
    },

    GT: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    GN: {
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    GY: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    HT: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    HN: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Department: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    HK: {
      Area: 1,
      District: 1,
      "Address line 1": 1,
      "Address line 2": 1,
    },

    HU: {
      City: 1,
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    IS: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    IN: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      PIN: 1,
      State: 1,
      zipLength: 6,
      isNumber: true,
      zipCheck: true,
    },

    ID: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Province: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    IR: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Province: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    IQ: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Province: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    IE: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      County: 1,
      Eircode: 1,
      zipLength: 7,
      isNumber: false,
      zipCheck: true,
    },

    IM: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    IL: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    IT: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      Province: 1,
    },

    JM: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Parish: 1,
      CEDEX: 1,
      zipLength: 50,
      isNumber: false,
    },

    JP: {
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
      Prefecture: 1,
      "Address line 1": 1,
      "Address line 2": 1,
    },

    JE: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    JO: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    KZ: {
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
      Province: 1,
      City: 1,
      "Address line 1": 1,
      "Address line 2": 1,
    },

    KE: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    KI: {
      "Address line 1": 1,
      "Address line 2": 1,
      Island: 1,
      City: 1,
    },

    KS: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    KW: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    KG: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    LA: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    LV: {
      "Address line 1": 1,
      "Address line 2": 1,
      Province: 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    LB: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    LS: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    LR: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    LY: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    LI: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    LT: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      Province: 1,
    },

    LU: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    MG: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    MW: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      CEDEX: 1,
      zipLength: 50,
      isNumber: false,
    },

    MY: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      State: 1,
    },

    MV: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    ML: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    MT: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    MQ: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      CEDEX: 1,
    },

    MR: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    MU: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    YT: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      CEDEX: 1,
    },

    MX: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      State: 1,
    },

    MD: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    MC: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      CEDEX: 1,
    },

    MN: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Province: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    ME: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    MA: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    MZ: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      Province: 1,
    },

    MM: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    NA: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    NR: {
      "Address line 1": 1,
      "Address line 2": 1,
      District: 1,
    },

    NP: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    NL: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    NC: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      CEDEX: 1,
    },

    NZ: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    NI: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      Department: 1,
    },

    NE: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    NG: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      State: 1,
    },

    MK: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    NO: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    OM: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    PK: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    PA: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Province: 1,
    },

    PG: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      Province: 1,
    },

    PY: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    PE: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      Province: 1,
    },

    PH: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      Province: 1,
    },

    PL: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    PT: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    PR: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      ZIP: 1,
      zipLength: 5,
      isNumber: true,
      zipCheck: true,
    },

    QA: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    RO: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
      Province: 1,
      City: 1,
    },

    RU: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Oblast: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    RW: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    WS: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    SM: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    SA: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    SN: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    RS: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    SC: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Island: 1,
    },

    SL: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    SG: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    SX: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    SK: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    SI: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    SB: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    SO: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Province: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    ZA: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    GS: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    KR: {
      State: 1,
      City: 1,
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    SS: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    ES: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      Province: 1,
    },

    LK: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    SH: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    LC: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    MF: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      CEDEX: 1,
    },

    VC: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    SD: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },
    SR: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    SE: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    CH: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    TW: {
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
      State: 1,
      City: 1,
      "Address line 1": 1,
      "Address line 2": 1,
    },

    TJ: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    TZ: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    TH: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Province: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    TG: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    TO: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    TT: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    TN: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    TR: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      Province: 1,
    },

    TM: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    TV: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Island: 1,
    },

    UG: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    UA: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Oblast: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    AE: {
      "Address line 1": 1,
      "Address line 2": 1,
      Emirate: 1,
    },

    GB: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
    },

    US: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      ZIP: 1,
      State: 1,
      zipLength: 5,
      isNumber: true,
      zipCheck: true,
    },

    UY: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      Province: 1,
    },

    UZ: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
      Province: 1,
    },

    VA: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    VE: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 0.5,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      State: 1,
    },

    VN: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
      Province: 1,
      "Postal code": 1,
      zipLength: 50,
      isNumber: false,
    },

    YE: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },

    ZM: {
      "Address line 1": 1,
      "Address line 2": 1,
      "Postal code": 0.5,
      zipLength: 50,
      isNumber: false,
      City: 0.5,
    },

    ZW: {
      "Address line 1": 1,
      "Address line 2": 1,
      City: 1,
    },
  };
};

export const initialValues: valuesProps = {
  x_card_num: "",
  x_exp_date: "",
  x_card_code: "",
  choldername: "",
  x_payment_method: "CC",
  x_city: "",
  x_address: "",
  address2: "",
  x_zip: "",
  x_state: "",
  x_country: "US",
  routing_number: "",
  account_number: "",
  bank_name: "",
  swift_code: "",
  card_funding_type: "credit",
  card_type: "",
  default: "N",
};
